module.exports = __webpack_public_path__ + "img/remove.3693345b.svg";